import { ICloneStore } from "common/interfaces/ICloneStore";
import { ProductResponse } from "repositories/dtos/responses/ProductResponse";
import { TiktokWidgetResponse } from "repositories/dtos/responses/TiktokWidgetResponse";
import { TemplateType } from "Dependencies/TikTokLayout/LayoutTemplateType";
import { AppSettingWidget } from "DefaultConfiguration/AppSettingWidget";
import { SourceTypeEnum } from "repositories/dtos/requests/GetVideoByJobRequest";

export interface ISettingProviderWidget {
  id?: string;
  title?: string;
  source?: number;
  valueSource?: string;
  layout?: TemplateType;
  header?: "enable" | "disable";
  titleHeader?: string;
  caption?: string;
  labelReadMore?: string;
  labelView?: string;
  showProfile?: "enable" | "disable";
  showNetworkIcon?: "enable" | "disable";
  accentColor?: string;
  itemBackground?: string;
  itemColor?: string;
  numberItemPerRow?: number;
  customCss?: string;
  products?: ProductResponse[];
  disableShowItems?: string[];
  itemSorts?: string[];
  numberItems?: number;
  itemsGetmore?: number;
  formatCurrentcy?: string;
}

export class SettingProviderWidget implements ISettingProviderWidget {
  id?: string;
  title?: string;
  source?: number;
  valueSource?: string;
  layout?: TemplateType;
  header?: "enable" | "disable";
  titleHeader?: string;
  caption?: string;
  labelReadMore?: string;
  labelView?: string;
  showProfile?: "enable" | "disable";
  showNetworkIcon?: "enable" | "disable";
  accentColor?: string;
  itemBackground?: string;
  itemColor?: string;
  numberItemPerRow?: number;
  customCss?: string;
  numberItems?: number;
  products?: ProductResponse[];
  disableShowItems?: string[];
  itemSorts?: string[];
  itemsGetmore?: number;
  formatCurrentcy?: string;
  constructor(dto?: TiktokWidgetResponse) {
    this.id = dto?.id;
    this.title = dto?.widgetTitle || "";
    this.source =
      dto?.sourceType.toLowerCase() === "hashtag"
        ? SourceTypeEnum.HashTag
        : SourceTypeEnum.UserName;
    this.valueSource = dto?.valueSource || "";
    this.layout = dto?.setting.layoutType || 0;
    this.header = dto?.header.enable ? "enable" : "disable";
    this.titleHeader = dto?.header.title || "";
    this.caption = dto?.header.caption || "";
    this.labelReadMore = dto?.setting.labelReadMore || "";
    this.labelView = dto?.setting.labelViewMore || "";
    this.showProfile = dto?.setting.showProfile ? "enable" : "disable";
    this.showNetworkIcon = dto?.setting.showNetworkIcon ? "enable" : "disable";
    this.accentColor = dto?.setting.accentColor || "";
    this.itemBackground = dto?.setting.backGround || "";
    this.itemColor = dto?.setting.color || "";
    this.numberItemPerRow =
      dto?.setting.numberPerRow || AppSettingWidget.Tiktok.NumberPerRow;
    this.customCss = dto?.setting.customCss || "";
    this.numberItems =
      dto?.setting.numberItems || AppSettingWidget.Tiktok.LimitVideos;
    this.products = dto?.products || [];
    this.disableShowItems = dto?.disableShowItems || [];
    this.itemSorts = dto?.itemSorts || [];
    this.itemsGetmore =
      dto?.itemsGetmore || AppSettingWidget.Tiktok.DefaultItemGetmore;
    this.formatCurrentcy = dto?.shops?.currency || "";
  }
  ToDto = (): ISettingProviderWidget => {
    return this as ISettingProviderWidget;
  };

  AddFormatCurrentcy = (formatCurrentcy?: string) => {
    this.formatCurrentcy = formatCurrentcy;
    return this;
  };
}

export type WidgetStatus = "FirstCreated" | "Undefined";
export class WidgetStoreModelDto {
  step: number;
  mobile: boolean;
  settings: ISettingProviderWidget;
  products: ProductResponse[] | undefined;
  count: number | undefined;
  status: WidgetStatus;
  sequenceNumber: number;
  workingSearch: boolean;
  constructor() {
    this.step = 0;
    this.mobile = false;
    this.products = [];
    this.count = undefined;
    this.status = "Undefined";
    this.sequenceNumber = 0;
    this.workingSearch = false;
    this.settings = {
      id: "",
      title: "",
      source: 0,
      valueSource: "",
      layout: TemplateType.Slider,
      header: "enable",
      showProfile: "enable",
      showNetworkIcon: "enable",
      titleHeader: AppSettingWidget.Tiktok.Title,
      caption: AppSettingWidget.Tiktok.Caption,
      labelReadMore: AppSettingWidget.Tiktok.LabelReadmore,
      labelView: AppSettingWidget.Tiktok.LabelView,
      accentColor: AppSettingWidget.Tiktok.AccentColor,
      itemBackground: AppSettingWidget.Tiktok.ItemBackground,
      itemColor: AppSettingWidget.Tiktok.ItemColor,
      numberItemPerRow: AppSettingWidget.Tiktok.NumberPerRow,
      numberItems: AppSettingWidget.Tiktok.LimitVideos,
      itemsGetmore: AppSettingWidget.Tiktok.DefaultItemGetmore,
      customCss: "",
      products: [],
      itemSorts: [],
      disableShowItems: [],
    };
  }
}

export class WidgetStoreModel implements ICloneStore<WidgetStoreModel> {
  protected _step: number;
  protected _mobile: boolean;
  protected _products: ProductResponse[];
  protected _settings: ISettingProviderWidget;
  protected _count: number | undefined;
  protected _status: WidgetStatus;
  protected _sequenceNumber: number;
  protected _workingSearch: boolean;
  constructor(_dto?: WidgetStoreModelDto) {
    this._step = _dto?.step || -1;
    this._mobile = _dto?.mobile || false;
    this._products = _dto?.products || [];
    this._count = _dto?.count ?? -1;
    this._status = _dto?.status ?? "Undefined";
    this._sequenceNumber = _dto?.sequenceNumber ?? 0;
    this._workingSearch = _dto?.workingSearch ?? false;
    this._settings = _dto?.settings || {
      id: "",
      title: "",
      source: 0,
      valueSource: "",
      layout: TemplateType.Slider,
      header: "enable",
      showProfile: "enable",
      showNetworkIcon: "enable",
      titleHeader: AppSettingWidget.Tiktok.Title,
      caption: AppSettingWidget.Tiktok.Caption,
      labelReadMore: AppSettingWidget.Tiktok.LabelReadmore,
      labelView: AppSettingWidget.Tiktok.LabelView,
      accentColor: AppSettingWidget.Tiktok.AccentColor,
      itemBackground: AppSettingWidget.Tiktok.ItemBackground,
      itemColor: AppSettingWidget.Tiktok.ItemColor,
      numberItemPerRow: AppSettingWidget.Tiktok.NumberPerRow,
      numberItems: AppSettingWidget.Tiktok.LimitVideos,
      itemsGetmore: AppSettingWidget.Tiktok.DefaultItemGetmore,
      customCss: "",
      products: [],
      itemSorts: [],
      disableShowItems: [],
    };
  }

  public get workingSearch(): boolean {
    return this._workingSearch;
  }

  public set workingSearch(v: boolean) {
    this._workingSearch = v;
  }

  public get sequenceNumber(): number {
    return this._sequenceNumber;
  }

  public set sequenceNumber(v: number) {
    this._sequenceNumber = v;
  }

  public get status(): WidgetStatus {
    return this._status;
  }

  public set status(v: WidgetStatus) {
    this._status = v;
  }

  public get count(): number | undefined {
    return this._count;
  }

  public set count(v: number | undefined) {
    this._count = v;
  }

  public get products(): ProductResponse[] {
    return this._products;
  }

  public set products(v: ProductResponse[]) {
    this._products = v;
  }

  public get mobile(): boolean {
    return this._mobile;
  }

  public set mobile(v: boolean) {
    this._mobile = v;
  }

  public get settings(): ISettingProviderWidget {
    return this._settings;
  }

  public set settings(v: ISettingProviderWidget) {
    this._settings = v;
  }

  public get step(): number {
    return this._step;
  }

  public set step(v: number) {
    this._step = v;
  }
  Clone(): WidgetStoreModel {
    let dto = this.ToDto();
    return new WidgetStoreModel(dto);
  }

  ToDto(): WidgetStoreModelDto {
    return {
      step: this._step,
      settings: this._settings,
      mobile: this._mobile,
      products: this._products,
      count: this._count,
      status: this._status,
      sequenceNumber: this._sequenceNumber,
      workingSearch: this._workingSearch,
    };
  }
}
